export default __webpack_public_path__ + "fonts/Circular-Book.woff";